import { translate } from 'i18n/i18n'
import { ndviChangeHeatmapScale, ndviStaticHeatmapScale } from 'settings/colors'

const LegendScale = ({
  title,
  scale,
  leftLabel,
  rightLabel,
}: {
  title: string
  scale: readonly string[]
  leftLabel: string
  rightLabel: string
}) => (
  <div css={{ display: 'flex', flexDirection: 'column', width: 200 }}>
    <div css={{ fontSize: 12, fontWeight: 'bold', marginLeft: 10 }}>{title}</div>
    <div css={{ width: '100%', display: 'flex', padding: 10 }}>
      {scale.map((rgbaString, index) => (
        <div key={index} css={{ flex: 1, height: 12, backgroundColor: rgbaString }} />
      ))}
    </div>
    <div css={{ marginTop: 6, fontSize: 12, display: 'flex', justifyContent: 'space-between' }}>
      <div>{leftLabel}</div>
      <div>{rightLabel}</div>
    </div>
  </div>
)

export const NDVILegend = () => (
  <div css={{ display: 'flex', gap: 50, alignItems: 'end', marginBottom: 20 }}>
    <LegendScale
      title={translate.phrases.banyanApp('NDVI Index')}
      scale={ndviStaticHeatmapScale}
      leftLabel={translate.phrases.banyanApp('Absent')}
      rightLabel={translate.phrases.banyanApp('Dense')}
    />
    <LegendScale
      title={translate.phrases.banyanApp('NDVI Difference')}
      scale={ndviChangeHeatmapScale}
      leftLabel={translate.phrases.banyanApp('Decreased')}
      rightLabel={translate.phrases.banyanApp('Increased')}
    />
  </div>
)
